import { render, staticRenderFns } from "./goods-manage.vue?vue&type=template&id=67a5fd80&scoped=true&"
import script from "./goods-manage.vue?vue&type=script&lang=js&"
export * from "./goods-manage.vue?vue&type=script&lang=js&"
import style0 from "./goods-manage.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./goods-manage.vue?vue&type=style&index=1&id=67a5fd80&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a5fd80",
  null
  
)

export default component.exports